import React, { Component } from 'react';
import axios from 'axios'
import { serverIp } from '../../../../config/constants'
import { Form, Segment, Button, Divider, } from 'semantic-ui-react'
import * as UiConsts from '../../../../config/UiConstants';

import createBrowserHistory from 'history/createBrowserHistory';
import ViewLargeProjectOrderEntry_options_card from './ViewLargeProjectOrderEntry_options_card';
const history = createBrowserHistory({ forceRefresh: true });

class ViewItemOptionsInOrder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            orderStatuses: [],
            itemOptions: []
        }
    }

    componentDidMount() {
        console.log("++++++++:componentDidMount");
    }


    getSingleLargeProjectItemModel = () => {
        console.log("++++++++:updateStatus");
        console.log("this.props.projectId:" + this.props.projectId)
        console.log("this.props.user.email:" + this.props.user.email)
        console.log("dateNum:" + this.state.dateNum)

        if (!this.props.largeProjectItemId) {
            alert("No largeProjectItemId")
        } else if (!this.props.user.email) {
            alert("No Entered By Provided")
        } else {
            console.log("sending data..");

            this.setState({ loading: true });

            axios.post(serverIp + "large_project_items/getSingleLargeProjectItemModel", {
                apiKey: "getSingleLargeProjectItemModel",
                largeProjectItemId: this.props.largeProjectItemId,
                enteredBy: this.props.user.email
            })
                .then((response) => {
                    this.setState({ loading: false })
                    console.log(JSON.stringify(response.data,null,3));

                    if (response.data.result) {
                        console.log("true.. getSingleLargeProjectItemModel");
                        //alert(response.data.message);

                        if (response.data.largeProject_item_model) {
                            this.setState({
                                itemOptions:response.data.largeProject_item_model.itemOptions
                            })
                        }

                    } else {
                        console.log("FAILED");

                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }
    }


    render() {

        const viewOptions = this.state.itemOptions.length > 0
            ? <ViewLargeProjectOrderEntry_options_card largeProjectItemOptions={this.state.itemOptions} />
            :''

        return (this.state.loading ? <UiConsts.LoadingComponent /> : <div>
            <Divider horizontal>{'VIEW ITEM OPTIONS'}</Divider>

            <Button fluid color='brown' onClick={this.getSingleLargeProjectItemModel}>VIEW OPTIONS</Button>

            {viewOptions}

        </div>);
    }
}

export default ViewItemOptionsInOrder;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjectOrderEntry/ViewItemOptionsInOrder.js